import type { ApiBody, ApiResponse } from '../../api/contract';
import type { ListQuery } from '../../shared/data/types';

export type GameTypeDetail = ApiResponse<'/api/v1/game-types/{id}', 'get'>['data'];
export type GameTypeSummary = GameTypeDetail;
export type GameDetail = ApiResponse<'/api/v1/games/{id}', 'get'>['data'];
export type GameSummary = GameDetail;
export type GameTypeOption = GameDetail['gameType'];
export type MasterStatus = GameTypeDetail['status'];
export type MasterSort = 'code' | 'name' | 'status' | 'createdAt' | 'updatedAt';

export interface GameTypeFilters {
  readonly code: string;
  readonly name: string;
  readonly status: MasterStatus | '';
}

export interface GameFilters extends GameTypeFilters {
  readonly gameTypeId: string;
}

export type GameTypeListQuery = ListQuery<MasterSort, GameTypeFilters>;
export type GameListQuery = ListQuery<MasterSort, GameFilters>;
export type CreateGameTypeInput = ApiBody<'/api/v1/game-types', 'post'>;
export type UpdateGameTypeInput = ApiBody<'/api/v1/game-types/{id}', 'patch'>;
export type ChangeGameTypeStatusInput = ApiBody<'/api/v1/game-types/{id}/status', 'post'>;
export type CreateGameInput = ApiBody<'/api/v1/games', 'post'>;
export type UpdateGameInput = ApiBody<'/api/v1/games/{id}', 'patch'>;
export type ChangeGameStatusInput = ApiBody<'/api/v1/games/{id}/status', 'post'>;
export type PartnerGame = ApiResponse<'/api/v1/partners/{partnerId}/games/{gameId}', 'get'>['data'];
export type CreatePartnerGameInput = ApiBody<'/api/v1/partners/{partnerId}/games', 'post'>;
export type UpdatePartnerGameInput = ApiBody<
  '/api/v1/partners/{partnerId}/games/{gameId}',
  'patch'
>;
export type ChangePartnerGameStatusInput = ApiBody<
  '/api/v1/partners/{partnerId}/games/{gameId}/status',
  'post'
>;

export function normalizeMasterCode(value: string): string {
  return value.trim().toUpperCase();
}
